/**
 * 上传/导入
 */
import { pgMessage } from '../../message/index'
import { PgDialogUpdateResultUpdate } from '../../dialog-update-result/index'
import { post, http } from '../../../utils/index'
import { Loading } from 'element-ui'

function validateFile({ files, maxSize, accept }) {
  if (files.length > 0) {
    for (const file of files) {
      if (file.size > maxSize * 1024) {
        pgMessage.error(`请上传不大于${parseInt(maxSize / 1024)}M的文件`)
        return
      }
      if (accept.length > 0 && accept.indexOf(file.name.split('.').pop()) === -1) {
        pgMessage.error(`请上传类型为${accept.join('/')}的文件`)
        return
      }
    }

    return true
  }
}

export async function leadin({ property, parameter }) {
  return new Promise((resolve, reject) => {
    const {
      multiple,
      accept = [
        'jpg',
        'jpeg',
        'png',
        'bmp',
        'gif',
        'docx',
        'doc',
        'xlsx',
        'xls',
        'pdf',
        'rar',
        'zip',
      ],
      maxSize = 10240,
      fileUrl = 'rest/ezcomp/file/uploadFile',
      url,
      method = 'get',
      params,
      //仅支持message和不提示， 有进度条的情况不提示（后端的异步任务返回接口中 total > 0 就使用进度条方式提示
      successTip = 'message',
      resultTitle = '导入',
      resultTextTemplate = '$title$完毕！本次$title$成功$success$条, 失败$faild$',
    } = property
    const inputFile = document.createElement('input')
    inputFile.type = 'file'
    inputFile.style.display = 'none'
    if (multiple) {
      inputFile.multiple = true
    }
    if (accept) {
      inputFile.accept = accept.join(',')
    }
    inputFile.click()
    document.body.appendChild(inputFile)

    async function changeEvEnt() {
      setTimeout(async () => {
        if (validateFile({ files: inputFile.files, maxSize, accept })) {
          const formData = new FormData()
          for (let file of inputFile.files) {
            formData.append('file', file)
          }
          Object.keys(parameter).forEach((im) => {
            formData.append(im, parameter[im])
          })

          //开始上传
          let loadingInstance = Loading.service({ background: 'rgba(0,0,0,0)', fullscreen: true })
          const [fileRes] = await post(fileUrl, formData)
          const [res] = await PgDialogUpdateResultUpdate(async (update) =>
            url
              ? await http[method](url, Object.assign({}, fileRes.data, params, parameter), {
                  doingCallback(progressTask) {
                    if (progressTask.total > 0) {
                      loadingInstance?.close()
                      loadingInstance = null
                      update({
                        title: resultTitle,
                        resultData: progressTask,
                        downLoadFailUrl: progressTask.data,
                        textTemplate: resultTextTemplate,
                      })
                    }
                  },
                })
              : []
          )
          loadingInstance?.close()
          inputFile.remove()
          if ((url && res) || !url) {
            if (
              successTip === 'message' &&
              !res?.faild &&
              (!res?.success || res?.success === true)
            ) {
              pgMessage.success(res?.msg ?? '成功！')
            }
            resolve(res ?? fileRes)
          } else {
            reject()
          }
        } else {
          inputFile.remove()
          reject()
        }
      }, 200)
      window.removeEventListener('focus', changeEvEnt)
    }
    window.addEventListener('focus', changeEvEnt)
  })
}
